module.exports = __webpack_public_path__ + "static/media/compass-group-ireland.b8befe91.jpg";